import { useEffect } from 'react';
import { useAuth, redirectToAdminWithHandoff } from '@practium/features/auth';
import { useAppNavigation } from '@practium/features/navigation';
import { useCreateHandoff } from '@practium/features/api';
import { UserRole } from '@practium/shared';

export function AdminRedirectGuard({ children }: Readonly<{ children: React.ReactNode }>) {
	const { user, isLoading } = useAuth();
	const { createAppLink } = useAppNavigation();
	const { mutateAsync: createHandoff } = useCreateHandoff();

	useEffect(() => {
		if (!isLoading && user?.role === UserRole.Admin) {
			redirectToAdminWithHandoff({ createHandoff, createAppLink });
		}
	}, [user, isLoading, createHandoff, createAppLink]);

	if (isLoading || user?.role === UserRole.Admin) {
		return null;
	}
	return <>{children}</>;
}
